export interface BaseWidget {
  trackerWidgetData: {
    kbPageId: string
    source: 'reference_tab' | 'kb_page'
    widgetValue: Record<string, any>
    widgetType: string
    widgetId: string
  }
}

interface BaseReferenceWidget extends BaseWidget {
  topicId?: number
  topicName?: string
}

export interface IAksiNyata extends BaseReferenceWidget {
  id: string
  author: string
  title: string
  thumbnailUrl: string
  url: string
}

export interface IAssessment extends BaseReferenceWidget {
  id: string
  kelas: string
  title: string
  subtitle: string
  url: string
}

export interface IModule extends BaseReferenceWidget {
  id: string
  title: string
  duration: number
  materiAmount: number
  url: string
}

export interface IPageCard extends BaseReferenceWidget {
  id: string
  excerpt: string
  title: string
  thumbnailUrl: string
  url: string
}

export interface IGenericPageCard extends BaseWidget {
  excerpt: string
  title: string
  thumbnailUrl: string
  url: string
}

export interface IToolkit extends BaseReferenceWidget {
  id: string
  fase: string
  kelas: string
  title: string
  thumbnailUrl: string
  toolkitType: string
  url: string
}

export interface ITopic extends BaseReferenceWidget {
  id: string
  moduleAmount: number
  title: string
  subtitle: string
  thumbnailUrl: string
  url: string
}

export enum ButtonColor {
  BLUE = 'blue',
  BLACK = 'black',
  WHITE = 'white',
  RED = 'red',
}

export interface IButton extends BaseWidget {
  color: ButtonColor
  label: string
  url: string
}

export interface IDocument extends BaseWidget {
  title: string
  subtitle: string
  url: string
}

export enum HeadingSize {
  MD = 'heading-md',
  LG = 'heading-lg',
}

export interface IHeading extends BaseWidget {
  size: HeadingSize
  text: string
}

export interface IText extends BaseWidget {
  text: string
}

export interface IVideoCard extends BaseWidget {
  title: string
  thumbnailUrl: string
  url: string
}

export enum ImageRatio {
  'aspect-auto' = 'aspect-auto',
  'aspect-2/1' = 'aspect-2/1',
  'aspect-3/1' = 'aspect-3/1',
  'aspect-square' = 'aspect-square',
}
export interface IImage extends BaseWidget {
  altText?: string
  imageUrl: string
  ratio: ImageRatio
}
